import south480 from "./portfolio-southeast-dental-480.webp.asset.json";
import south960 from "./portfolio-southeast-dental-960.webp.asset.json";
import south1440 from "./portfolio-southeast-dental-1440.webp.asset.json";
import cooling480 from "./portfolio-2r-cooling-480.webp.asset.json";
import cooling960 from "./portfolio-2r-cooling-960.webp.asset.json";
import cooling1440 from "./portfolio-2r-cooling-1440.webp.asset.json";
import designs480 from "./portfolio-dental-designs-480.webp.asset.json";
import designs960 from "./portfolio-dental-designs-960.webp.asset.json";
import designs1440 from "./portfolio-dental-designs-1440.webp.asset.json";
import founder256 from "./founder-nathaniel-256.webp.asset.json";
import founder512 from "./founder-nathaniel-512.webp.asset.json";

function portfolio(small: { url: string }, medium: { url: string }, large: { url: string }) {
  return { src: medium.url, srcSet: `${small.url} 480w, ${medium.url} 960w, ${large.url} 1440w` };
}

export const portfolioPhotos = {
  southEastDental: portfolio(south480, south960, south1440),
  cooling: portfolio(cooling480, cooling960, cooling1440),
  dentalDesigns: portfolio(designs480, designs960, designs1440),
};
export const founderPhoto = { src: founder512.url, srcSet: `${founder256.url} 256w, ${founder512.url} 512w` };